
/**
 * SVG representation of the Google logo (in color).
 */
const AuthLoginMethodLogoGoogle = () => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 36 36" role="img" aria-hidden="true">
    <path
      fill="#4285F4"
      d="M29.3 18.26c0-.98-.09-1.7-.26-2.45H17.88v4.46h6.55A5.87 5.87 0 0122 24.16l-.02.15 3.53 2.76.24.02C28 25 29.3 21.92 29.3 18.26z"
    />
    <path
      fill="#34A853"
      d="M17.88 30c3.21 0 5.9-1.07 7.87-2.9L22 24.15c-1 .7-2.35 1.2-4.12 1.2a7.16 7.16 0 01-6.76-4.99l-.14.01-3.66 2.87-.05.14a11.87 11.87 0 0010.61 6.6z"
    />
    <path
      fill="#FBBC05"
      d="M11.12 20.37a7.45 7.45 0 01-.01-4.74v-.16l-3.72-2.92-.12.06a12.1 12.1 0 000 10.77l3.85-3z"
    />
    <path
      fill="#EB4335"
      d="M17.88 10.64c2.24 0 3.74.97 4.6 1.79l3.35-3.31A11.36 11.36 0 0017.88 6c-4.64 0-8.66 2.7-10.61 6.61l3.84 3.02a7.2 7.2 0 016.77-5z"
    />
  </svg>
);

export default AuthLoginMethodLogoGoogle;
